import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Send } from 'lucide-react';
import { SectionCard, FancyButton } from '../../pages';

/**
 * Connect With Us section — extracted from App.js HomePage (Feb 2026 P3 refactor).
 * Contact/feedback form with category selector.
 */
const ConnectWithUsSection = ({ form, onFormChange, onSubmit }) => (
  <SectionCard
    icon={MessageCircle}
    title="Connect With Us"
    subtitle="We'd love to hear from you"
    gradient="vesper"
    delay={0.3}
  >
    <motion.form
      className="grid gap-3 sm:gap-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.7 }}
      onSubmit={onSubmit}
      data-testid="connect-with-us-form"
    >
      <input
        className="w-full border-2 border-blue-200 rounded-xl sm:rounded-2xl px-4 py-3 focus:border-blue-400 transition-colors bg-white/50 backdrop-blur-sm text-base min-h-[48px]"
        placeholder="Your name *"
        value={form.name}
        onChange={(e) => onFormChange({ name: e.target.value })}
        required
        data-testid="connect-name"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <input
          className="w-full border-2 border-blue-200 rounded-xl sm:rounded-2xl px-4 py-3 focus:border-blue-400 transition-colors bg-white/50 backdrop-blur-sm text-base min-h-[48px]"
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={(e) => onFormChange({ email: e.target.value })}
          data-testid="connect-email"
        />
        <input
          className="w-full border-2 border-blue-200 rounded-xl sm:rounded-2xl px-4 py-3 focus:border-blue-400 transition-colors bg-white/50 backdrop-blur-sm text-base min-h-[48px]"
          placeholder="Phone"
          value={form.phone}
          onChange={(e) => onFormChange({ phone: e.target.value })}
          data-testid="connect-phone"
        />
      </div>
      <select
        className="w-full border-2 border-blue-200 rounded-xl sm:rounded-2xl px-4 py-3 focus:border-blue-400 transition-colors bg-white/50 backdrop-blur-sm text-base min-h-[48px]"
        value={form.category}
        onChange={(e) => onFormChange({ category: e.target.value })}
        data-testid="connect-category"
      >
        <option value="general_inquiry">General Inquiry</option>
        <option value="prayer_request">Prayer Request</option>
        <option value="counselling">Counselling</option>
        <option value="testimony">Testimony</option>
        <option value="membership">Membership</option>
        <option value="giving">Giving</option>
        <option value="feedback">Feedback</option>
      </select>
      <input
        className="w-full border-2 border-blue-200 rounded-xl sm:rounded-2xl px-4 py-3 focus:border-blue-400 transition-colors bg-white/50 backdrop-blur-sm text-base min-h-[48px]"
        placeholder="Subject"
        value={form.subject}
        onChange={(e) => onFormChange({ subject: e.target.value })}
        data-testid="connect-subject"
      />
      <textarea
        className="w-full border-2 border-blue-200 rounded-xl sm:rounded-2xl px-4 py-3 focus:border-blue-400 transition-colors bg-white/50 backdrop-blur-sm resize-none text-base"
        placeholder="Your message *"
        rows={3}
        value={form.message}
        onChange={(e) => onFormChange({ message: e.target.value })}
        required
        data-testid="connect-message"
      />
      <FancyButton
        type="submit"
        variant="info"
        className="flex items-center justify-center gap-2 w-full"
        data-testid="connect-submit"
      >
        <Send className="w-4 h-4" />
        <span>Send Message</span>
      </FancyButton>
    </motion.form>
  </SectionCard>
);

export default ConnectWithUsSection;
